<template>
    <div class="setting">
        <el-form ref="form" label-width="150px" class="form">
          <el-form-item label="活动显示">
            <el-switch v-model="info.is_show_activity"></el-switch>
          </el-form-item>
          <el-form-item label="活动选择">
            <el-select class="select" v-model="info.activity_ids" multiple placeholder="请选择">
              <el-option
                v-for="item in activityList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
                clearable>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="在线电影院显示">
            <el-switch v-model="info.is_show_cinema"></el-switch>
          </el-form-item>
          <el-form-item label="在线电影院选择">
            <el-select class="select" v-model="info.cinema_ids" multiple placeholder="请选择">
              <el-option
                v-for="item in movies"
                :key="item.id"
                :label="item.title + ' (' + (item.price / 100 ) + '元)'"
                :value="item.id"
                clearable>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数字档案馆显示">
            <el-switch v-model="info.is_show_archive"></el-switch>
          </el-form-item>
          <el-form-item label="数字档案馆选择">
            <el-select class="select" v-model="info.archive_ids" multiple placeholder="请选择">
              <el-option
                v-for="item in topicList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
                clearable>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submit">保存</el-button>
          </el-form-item>
        </el-form>
    </div>
</template>
<script>
  import request from '@/utils/request'

  export default {
    name: 'setting',
    components: {
    },
    data () {
      return {
        info: {
        },
        movies: [],
        topicList: []
      }
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {

      request({
        url: '/vip-page-setting'
      }).then(res => {
        this.info = res.data.setting
        // this.total = res.data.item_total
      })


      request({
        url: '/movie'
      }).then(res => {
        this.movies = res.data.list
      })

      request({
        url: '/movie/topics'
      }).then(res => {
        this.topicList = res.data.list
      })


      request({
        url: '/movie/articles',
        params: {
          per_page: 200,
          page: 1,
          // type: 'movie_panorama'
        }
      }).then(res => {
        this.activityList = res.data.list
        // this.total = res.data.item_total
      })

    },

    submit () {
      request({
        url: '/vip-page-setting',
        method: 'POST',
        data: {
          setting: this.info
        }
      }).then(res => {
        this.$message.success('保存成功!')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.select {
  width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/views/vip/pageSetting.vue